import React from 'react'
import styled, { keyframes } from 'styled-components'

// const spin = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;

  background-color: #001d53;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999999999; /* Sempre no topo */
`

const LogoText = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 56px; /* Aumentei um pouco */
  font-weight: 900;
  color: #ffffff;
  margin: 0;
  letter-spacing: -2px;
  animation: ${pulse} 2s infinite ease-in-out;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
`

const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  color: #e0e0e0;
  text-transform: uppercase;
  letter-spacing: 4px;
  margin-top: 5px;
  animation: ${pulse} 2s infinite ease-in-out;

  margin-bottom: 40px;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
  font-weight: 500;
`

// const Spinner = styled.div`
//   width: 50px;
//   height: 50px;
//   border: 4px solid rgba(255, 255, 255, 0.3); /* Borda transparente branca */
//   border-top: 4px solid #ffffff; /* Topo branco brilhante para destacar no fundo escuro */
//   border-radius: 50%;
//   animation: ${spin} 1s linear infinite;
// `

export default function LoadingScreen() {
  return (
    <Container>
      <div style={{ textAlign: 'center' }}>
        <LogoText>GID</LogoText>
        <Subtitle>Gestão de Informações de Distribuidores</Subtitle>
      </div>
      {/* <Spinner /> */}
    </Container>
  )
}
